/* ================================
   Dawn – Header Cart Count + Total
   ================================ */

  document.addEventListener('DOMContentLoaded', function () {
    const cartForm = document.getElementById('cart');
    if (!cartForm) return;
    cartForm.addEventListener('submit', function (event) {
      let termsCheckbox = document.getElementById('CartTermsCheckbox1');
      if (!termsCheckbox) return;
      if (!termsCheckbox.checked) {
        event.preventDefault();
        alert('Please agree to the terms before checkout.');
      }else{
         cartForm.submit;
      }
    });
  });
// class ProgressBar extends HTMLElement {
//   setPercentage(value, max) {
//     if (!max || !value) return;
//     this.style.setProperty('--percent', `${(value / max) * 100}%`);
//   }
// }

// customElements.define('progress-bar', ProgressBar);
// class ProgressBar extends HTMLElement {
//   set(percent) {
//     this.style.setProperty('--percent', `${percent}%`);
//   }
// }

// customElements.define('progress-bar', ProgressBar);
class ProgressBar extends HTMLElement {
  static get observedAttributes() {
    return ['data-percent'];
  }
  update() {
    const percent = Math.min(parseFloat(this.dataset.percent || 0), 100);
    this.style.setProperty('--percent', `${percent}%`);
    console.log(percent, 'progress-bar')
  }
}
customElements.define('progress-bar', ProgressBar);

//Detect Customer location with delivery time
document.addEventListener("DOMContentLoaded", function(){
  /* ================= ADMIN ================= */
  const WAREHOUSE={
    lat:window.deliverySettings.warehouseLat,
    lng:window.deliverySettings.warehouseLng
  };
  //const ONE_DAY_DISTANCE=100;
  const ONE_DAY_DISTANCE = window.deliverySettings.distance || 100;

  /* ================= ELEMENTS ================= */
  const headerBtn=document.querySelector('.header__delivery');
  const popup=document.querySelector('.header-delivery-popup');
  const overlay=document.querySelector('.header-delivery-popup-overlay');
  const closeIcon=document.querySelector('.close-icon');

  /* ================= CHECK STORED LOCATION ================= */
  function hasLocation(){
    return !!localStorage.getItem("userLocation");
  }

  function popupDismissed(){
    return localStorage.getItem("locationPopupClosed") === "yes";
  }
  /* ================= FORCE POPUP FIRST VISIT ================= */
  //if(!hasLocation()){
  if(!hasLocation() && !popupDismissed()){
  popup.style.display='block';
  overlay.style.display='block';
  //if(closeIcon) closeIcon.style.display='none';
  document.body.style.overflow='hidden';
  }

  function openLocationPopup(){
    popup.style.display='block';
    overlay.style.display='block';

    if(closeIcon){
      closeIcon.style.display='block';
    }
    /*if(!hasLocation() && closeIcon){
      closeIcon.style.display='none';
    } else if(closeIcon){
      closeIcon.style.display='block';
    }*/
  }
  /* ================= HEADER CLICK ================= */
  headerBtn?.addEventListener('click',openLocationPopup);
  // headerBtn?.addEventListener('click',()=>{
  //   popup.style.display='block';
  //   overlay.style.display='block';
  //   if(!hasLocation() && closeIcon){
  //     closeIcon.style.display='none';
  //   }
  // });

  /* ================= SAFE CLOSE ================= */
  /*function closePopup(){
  popup.style.display='none';
  overlay.style.display='none';
  document.body.style.overflow='auto';
  }*/
 function closePopup(){
  popup.style.display='none';
  overlay.style.display='none';
  document.body.style.overflow='auto';

  localStorage.setItem("locationPopupClosed", "yes");
}

  function unlockPopup(){
    const closeIcon=document.querySelector('.close-icon');
    const overlay=document.querySelector('.header-delivery-popup-overlay');

    if(closeIcon) closeIcon.style.display='block';
    document.body.style.overflow='auto';
  }
  closeIcon?.addEventListener('click',closePopup);
  document.addEventListener('click',function(e){

    if(!popup || popup.style.display!=='block') return;

    const insidePopup = popup.contains(e.target);
    const headerClick = headerBtn?.contains(e.target);

    if(!insidePopup && !headerClick){
      if(localStorage.getItem("userLocation")){
          closePopup();
      }
    }
  });

    // overlay?.addEventListener('click',closePopup);
    overlay?.addEventListener('click',function(){
    if(!localStorage.getItem("userLocation")) return;
    closePopup();
  });

  /* ================= DETECT GPS ================= */
  document.querySelector('.detect-user-location')?.addEventListener('click',function(e){
    e.preventDefault();
    navigator.geolocation.getCurrentPosition(function(pos){

      const lat=pos.coords.latitude;
      const lng=pos.coords.longitude;

      reverseAddress(lat,lng,function(address){
        //If not AU, address will be empty
        if(!address){
          alert("Delivery available only in Australia");
          return; // DO NOT SAVE
        }
        saveLocation(lat,lng,address);
        processLocation(lat,lng,address);
      });
    });
  });

  /* ================= GOOGLE AUTOCOMPLETE (ONLY ONCE) ================= */
  setTimeout(initGoogleAutocomplete,1200);
  function initGoogleAutocomplete(){
    const input=document.getElementById("location-input");
    if(!input || !window.google) return;

    // const auto=new google.maps.places.Autocomplete(input,{types:['geocode']});
    const auto = new google.maps.places.Autocomplete(input,{
      types:['geocode'],
      componentRestrictions:{ country:'au' }   // ONLY AUSTRALIA
    });
    // auto.addListener("place_changed",function(){

    //   const place=auto.getPlace();
    //   if(!place.geometry) return;

    //   const lat=place.geometry.location.lat();
    //   const lng=place.geometry.location.lng();
    //   const address=place.formatted_address || input.value;

    //   saveLocation(lat,lng,address);
    //   processLocation(lat,lng,address);
    // });
    auto.addListener("place_changed",function(){

      const place = auto.getPlace();
      if(!place.geometry) return;

      /* CHECK COUNTRY */
      const country = place.address_components?.find(c=>c.types.includes("country"));
      if(!country || country.short_name !== "AU"){
        alert("Please select an Australian address");
        return;
      }

      /* GET POSTCODE */
      // const postal = place.address_components?.find(c=>c.types.includes("postal_code"));
      // const postcode = postal ? postal.long_name : "";

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      const address = place.formatted_address || input.value;

      saveLocation(lat,lng,address);
      processLocation(lat,lng,address);
    });
  }

  /* ================= PROCESS LOCATION ================= */
  function processLocation(lat,lng,address){
    const popupText=document.getElementById("location-popup-text");
    const km=distanceKm(lat,lng,WAREHOUSE.lat,WAREHOUSE.lng);
//     console.log(
//   "User → Warehouse distance:",
//   km.toFixed(2) + " KM",
//   "| User:", lat + "," + lng,
//   "| Warehouse:", WAREHOUSE.lat + "," + WAREHOUSE.lng
// );
    let delivery = window.deliverySettings?.far || "Delivery in 7-9 Days";

    if(km <= ONE_DAY_DISTANCE){
      delivery = window.deliverySettings?.near || "Delivery in 5 Day";
    }

    document.querySelector('.header__delivery strong').innerText=delivery;
      if(address){
        document.querySelector('.delivery-address-text').innerText=address;
      }
      if(popupText){
        popupText.innerText="Change Location";
      }
    unlockPopup();
    closePopup();
    document.dispatchEvent(new CustomEvent("location:updated",{
      detail:{
        delivery:delivery,
        address:address
      }
    }));
  }

  /* ================= SAVE LOCATION ================= */
  // function saveLocation(lat,lng,address=""){
  //   const locality=address?address.split(",")[0]:"";
  //   const obj={
  //     coords:{
  //     type:"SET_LOCATION",
  //     lat:lat,
  //     lon:lng,
  //     locality:locality,
  //     landmark:address,
  //     cityName:locality,
  //     id:locality,
  //     isDefault:false,
  //     addressId:null
  //     }
  //   };
  //   localStorage.setItem("userLocation",JSON.stringify(obj));
  // }
  function saveLocation(lat, lng, address = "") {
    if (!address) return;

    const locality = address ? address.split(",")[0] : "";

    const obj = {
      coords: {
        type: "SET_LOCATION",
        lat: lat,
        lon: lng,
        locality: locality,
        landmark: address,
        cityName: locality,
        id: locality,
        isDefault: false,
        addressId: null
      }
    };
    localStorage.setItem("userLocation", JSON.stringify(obj));
    localStorage.removeItem("locationPopupClosed");
  }

  /* ================= RESTORE LOCATION ================= */
  const saved=localStorage.getItem("userLocation");
  const popupText = document.getElementById("location-popup-text");
  if(saved){

  const d=JSON.parse(saved);

  processLocation(d.coords.lat,d.coords.lon,d.coords.landmark);
  if(popupText){
    popupText.innerText = "Change Location";
  }
  }

  /* ================= DISTANCE ================= */
  function distanceKm(a,b,c,d){
    const R=6371;
    const dLat=(c-a)*Math.PI/180;
    const dLon=(d-b)*Math.PI/180;

    const x=Math.sin(dLat/2)**2+
    Math.cos(a*Math.PI/180)*Math.cos(c*Math.PI/180)*
    Math.sin(dLon/2)**2;

    return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
  }

  /* ================= REVERSE ADDRESS ================= */
  // function reverseAddress(lat,lng,callback){
  //   if(!window.google){ callback(""); return; }
  //   const geocoder=new google.maps.Geocoder();
  //   geocoder.geocode({location:{lat:lat,lng:lng}},function(res,status){

  //     if(status==="OK" && res[0]){
  //       callback(res[0].formatted_address);
  //     }else{
  //       callback("");
  //     }
  //   });
  // }

  function reverseAddress(lat,lng,callback){
    if(!window.google){ callback(""); return; }
    const geocoder=new google.maps.Geocoder();
    geocoder.geocode({
      location:{lat:lat,lng:lng}
    },function(res,status){
      if(status==="OK" && res[0]){

        const comp = res[0].address_components;
        const country = comp.find(c=>c.types.includes("country"));
        if(!country || country.short_name !== "AU"){
          alert("Delivery available only in Australia");
          callback("");
          return;
        }

        const postal = comp.find(c=>c.types.includes("postal_code"));
        const postcode = postal ? postal.long_name : res[0].formatted_address;
        callback(postcode);
      }else{
        callback("");
      }
    });
  }
  document.addEventListener('click', function(e){
    const editBtn = e.target.closest('.edit-location');
    if(!editBtn) return;
    e.preventDefault();
    openLocationPopup();
  });
});


//
document.addEventListener("DOMContentLoaded", function () {
    const headings = document.querySelectorAll(".footer-block__heading");

    headings.forEach(function (heading) {
        heading.addEventListener("click", function () {
            if (window.innerWidth <= 991) {

                this.classList.toggle("ftr-active");

                // Find next content (UL or wrapper)
                let content = this.parentElement.nextElementSibling;

                // If structure different, check inside closest block
                if (!content) {
                    content = this.closest("div").querySelector(
                        ".footer-block__details-content, .footer-link-wrapper"
                    );
                }
                if (content) {
                    slideToggle(content, 300);
                }
            }
        });
    });
});

// Slide Toggle Functions
function slideToggle(element, duration = 300) {
    if (window.getComputedStyle(element).display === "none") {
        slideDown(element, duration);
    } else {
        slideUp(element, duration);
    }
}

function slideUp(element, duration) {
    element.style.height = element.offsetHeight + "px";
    element.offsetHeight;

    element.style.transition = `height ${duration}ms ease`;
    element.style.overflow = "hidden";
    element.style.height = "0";

    setTimeout(() => {
        element.style.display = "none";
        element.style.removeProperty("height");
        element.style.removeProperty("overflow");
        element.style.removeProperty("transition");
    }, duration);
}

function slideDown(element, duration) {
    element.style.display = "block";
    let height = element.scrollHeight;

    element.style.height = "0";
    element.offsetHeight;

    element.style.transition = `height ${duration}ms ease`;
    element.style.overflow = "hidden";
    element.style.height = height + "px";

    setTimeout(() => {
        element.style.removeProperty("height");
        element.style.removeProperty("overflow");
        element.style.removeProperty("transition");
    }, duration);
}

//open cart drawer on footer cart icon clicks
document.addEventListener('click', function(e){
  const btn = e.target.closest('[data-cart-drawer]');
  if(!btn) return;

  e.preventDefault();

  const drawer = document.querySelector('cart-drawer');
  if(drawer){
    drawer.open();
  }
});

// show up tooltip in cart drawer
document.addEventListener("DOMContentLoaded", function () {

  const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

  /* ── DESKTOP: delegated hover (works for dynamic cart drawer elements) ── */
  document.addEventListener("mouseover", function (e) {
    if (isMobile()) return;
    const wrapper = e.target.closest(".tooltip-wrapper");
    if (wrapper) wrapper.classList.add("active");
  });

  document.addEventListener("mouseout", function (e) {
    if (isMobile()) return;
    const wrapper = e.target.closest(".tooltip-wrapper");
    if (wrapper) wrapper.classList.remove("active");
  });

  /* ── MOBILE + DESKTOP click on icon ── */
  document.addEventListener("click", function (e) {

    const icon = e.target.closest(".tooltip-icon");

    if (icon) {
      const wrapper = icon.closest(".tooltip-wrapper");
      if (!wrapper) return;

      const isActive = wrapper.classList.contains("active");

      /* close all first */
      document.querySelectorAll(".tooltip-wrapper.active")
        .forEach(w => w.classList.remove("active"));

      /* reopen if it was closed */
      if (!isActive) wrapper.classList.add("active");

      e.stopPropagation();
      return;
    }

    /* click outside — close all */
    document.querySelectorAll(".tooltip-wrapper.active")
      .forEach(w => w.classList.remove("active"));

  });

});


// megamenu open left side drawer
// OPEN DRAWER
// document.addEventListener("DOMContentLoaded", function(){

//   const trigger = document.querySelector('[data-drawer-trigger]');
//   const drawer = document.getElementById('megaDrawer');

//   if(trigger){
//     trigger.addEventListener('click', function(e){
//       e.preventDefault();

//       // Stop default Dawn dropdown
//       const details = this.closest('details');
//       if(details) details.removeAttribute('open');

//       drawer.classList.add('active');
//     });
//   }

//   // Close drawer
//   document.querySelector('.mega-overlay').addEventListener('click', function(){
//     drawer.classList.remove('active');
//   });

// });
document.addEventListener('DOMContentLoaded', function () {

  const trigger = document.querySelector('[data-drawer-trigger]');
  const closeBtn = document.getElementById('close-product-sidebar');
  const drawer = document.querySelector('.mega-inner');
  const overlay = document.querySelector('.mega-menu-overlay');

  if (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      document.body.classList.add('overflow-hidden');
      drawer.classList.add('active');
      overlay.classList.add('active');
    });
  }
  function closeMegaDrawer() {
    document.body.classList.remove('overflow-hidden');
    if (drawer) drawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');

    // Reset all nested menu levels to their default hidden states
    document.querySelectorAll('.mega-content, .mega-level4, .grandchild1, .site-nav__dropdown-link').forEach(el => {
      el.classList.remove('active');
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeMegaDrawer);
  if (overlay) overlay.addEventListener('click', closeMegaDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('active')) {
      closeMegaDrawer();
    }
  });

  // LEFT → RIGHT SWITCH
  document.querySelectorAll('.mega-parent').forEach(item => {
    item.addEventListener('click', function (e) {
      const hasSubmenu = this.querySelector('.submenu-arrow-right');
      const link = this.querySelector('a');

      if (hasSubmenu) {
        // prevent navigation to expand submenu instead
        e.preventDefault();

        const handle = this.dataset.handle;

        document.querySelectorAll('.mega-content').forEach(el => {
          el.classList.remove('active');
        });

        const target = document.querySelector(`.mega-content[data-handle="${handle}"]`);
        if (target) target.classList.add('active');
        
        // Close Level 4 upon switching Level 2
        const level4Container = document.querySelector('.mega-level4');
        if (level4Container) {
          level4Container.classList.remove('active');
          document.querySelectorAll('.grandchild1').forEach(el => el.classList.remove('active'));
        }
        document.querySelectorAll('.site-nav__dropdown-link').forEach(el => el.classList.remove('active'));
      } else {
        // It has no children, so act as a normal link.
        // If they click on the LI margin physically outside the <a>, manual push to anchor URL.
        if (!e.target.closest('a') && link) {
          window.location.href = link.href;
        }
      }
    });
  });

  // LEVEL 3 → LEVEL 4 SLIDE OUT
  document.querySelectorAll('.site-nav__dropdown-link').forEach(link => {
    link.addEventListener('click', function(e) {
      const hasSubmenu = this.querySelector('.submenu-arrow-right');
      
      if (hasSubmenu) {
        e.preventDefault(); // Prevent navigating because it has children

        const level4Container = document.querySelector('.mega-level4');
        if (!level4Container) return;
        
        const targetId = this.getAttribute('data-target');
        const targetUl = targetId ? document.getElementById(targetId) : null;
        
        if (targetUl) {
          const isActive = this.classList.contains('active');
          
          // Close all level 3 actives and level 4 lists
          document.querySelectorAll('.site-nav__dropdown-link').forEach(el => el.classList.remove('active'));
          document.querySelectorAll('.grandchild1').forEach(el => el.classList.remove('active'));

          // If it wasn't already open, open it
          if (!isActive) {
            this.classList.add('active');
            targetUl.classList.add('active');
            level4Container.classList.add('active');
          } else {
            level4Container.classList.remove('active');
          }
        } else {
          // Close the level 4 container because there's no data
          document.querySelectorAll('.site-nav__dropdown-link').forEach(el => el.classList.remove('active'));
          document.querySelectorAll('.grandchild1').forEach(el => el.classList.remove('active'));
          level4Container.classList.remove('active');
        }
      }
      // If!hasSubmenu, do not call preventDefault().
      // The browser natively triggers the href navigation!
    });
  });
});

// Stop propagation ios issue for addtocart and notify button on product cards
document.addEventListener('click', function (e) {
  const quickAdd = e.target.closest('.quick-add-bulk');
  const notifyBtn = e.target.closest('.BIS_trigger');
  if (notifyBtn) {
    return;
  }
  if (quickAdd) {
    e.stopPropagation();
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   const container = document.querySelector(".collapsible-content"); // adjust if needed
//   const accordions = container.querySelectorAll("details");

//   accordions.forEach((item) => {
//     item.addEventListener("toggle", function () {
//       if (this.open) {
//         accordions.forEach((el) => {
//           if (el !== this) {
//             el.removeAttribute("open");
//           }
//         });
//       }
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".our-faqs");

  // stop if this section doesn't exist
  if (!container) return;

  const accordions = container.querySelectorAll(".collapsible-content details");

  accordions.forEach((item) => {
    item.addEventListener("toggle", function () {
      if (this.open) {
        accordions.forEach((el) => {
          if (el !== this) {
            el.removeAttribute("open");
          }
        });
      }
    });
  });
});

// readmore button show up in description product details page
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".about-product-description").forEach(function (wrapper) {
    
    const content = wrapper.querySelector(".desc-content");
    const button = wrapper.querySelector(".read-more-btn");

    if (!button) return;

    const fullText = content.innerHTML;
    const shortText = fullText.substring(0, 200) + "...";

    content.innerHTML = shortText;

    button.addEventListener("click", function () {
      if (button.classList.contains("active")) {
        content.innerHTML = shortText;
        button.textContent = "Read More";
        button.classList.remove("active");
      } else {
        content.innerHTML = fullText;
        button.textContent = "Read Less";
        button.classList.add("active");
      }
    });

  });
});